
export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: '',
    },
    static: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      element: '',
      isSVG: false,
    }
  },
  mounted() {
    this.$nextTick(async () => {
      if (this.static) {
        return
      }
      if (this.src.includes('svg')) {
        this.isSVG = true
        this.element = await this.useFetchAsset(this.src)
      } else {
        this.isSVG = false
      }
    })
  },
  methods: {
    async useFetchAsset(url) {
      return await this.$axios
        .get(this.buildUrl(url))
        .then((res) => res.data)
        .catch((err) => console.warn(err))
    },
    buildUrl(url = '') {
      if (!url) return
      const protocol = 'https://'
      const [, domain] = url.split('https://')

      return protocol + 's3.amazonaws.com/' + domain
    },
  },
}
